/*
 * @Author: mqlpcthree mql_pcthree@163.com
 * @Date: 2023-11-08 09:36:48
 * @LastEditors: mqlpcthree mql_pcthree@163.com
 * @LastEditTime: 2023-11-28 14:51:30
 * @FilePath: \mei_qi_zeroweb_endlyq\src\store\index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import Vue from 'vue'
import Vuex from 'vuex'
// import actions from './actions'
import actions from './actions'
import * as getters from './getters'
import state from './state'
import mutations from './mutations'

import member from './modules/bll' // 会员消费模块
import market from './modules/home/market' // 营销信息模块
import dataList from './modules/home/data/data'
import order from './modules/order'

// import createLogger from 'vuex/dist/logger'
// const debug = process.env.NODE_ENV !== 'production' // 数据中心模块

Vue.use(Vuex) // 注册插件
export default new Vuex.Store({
  actions,
  getters,
  state,
  mutations,
  modules: {
    member,
    market,
    dataList,
    order
  }
  // strict: debug, //会检测你的state修改是不是来源于mutations里面的方法  不是就会报错  线上不建议使用 最好是开发环境使用
  // plugins: debug ? [createLogger()] : [],
})



// WEBPACK FOOTER //
// ./src/store/index.js